<template>

  <!-- Channel Content -->
  <div
    class="channel-content">

    <div
      class="row q-col-gutter-md items-stretch">

      <div
        class="col-grow">

        <video-player
          :source="videoLink"
          :poster="posterLink"
          class="channel-content__player"
          :autoplay="!$q.platform.is.mobile"/>

      </div>

      <template
        v-if="showChat">

        <div
          v-if="chatLink"
          class="col-12 col-md-4">

          <video-player
            :source="chatLink"
            class="channel-content__chat"/>

        </div>

        <div
          v-else
          class="col-12 col-md-4">

          <group-chat
            :group-id="value.id"
            class="channel-content__chat"/>

        </div>

      </template>

    </div>

  </div>

</template>

<script>

  import {mapGetters} from 'vuex';
  import GroupChat from '@src/components/chat/group-chat';
  import VideoPlayer from '@src/components/player/video-player';

  export default {
    name: 'channel-content',
    props: {
      value: {
        type: Object,
        default: null,
      },
    },
    components: {
      GroupChat,
      VideoPlayer,
    },
    computed: {
      ...mapGetters('session', {
        isLoggedIn: 'isLoggedIn',
      }),
      showChat() {

        return this.isLoggedIn
          && this.value
          && this.value.showChat;
      },
      chatLink() {

        return this.value
          ? this.value.chatLink
          : '';
      },
      videoLink() {

        if (!this.value)
          return '';

        return this.value.useLink
          ? this.value.link
          : this.getFileUrl(this.value.file);
      },
      posterLink() {

        return this.getFileUrl(
          this.value && this.value.poster,
          null,
          undefined,
        );
      },
    },
  };

</script>

<style lang="scss">

  .channel-content {
    color: inherit;

    &__chat,
    &__player {
      overflow: hidden;
      border-radius: .4rem;
    }

    &__chat {
      height: 100%;
    }

    @media (max-width: $breakpoint-sm) {

      &__chat {
        min-height: 400px;
      }
    }
  }

</style>
